// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"dd3a8a090b83f20dc750","293":"390b363332fa940d2403","518":"77f5e9b7ac0051c5f79f","779":"a8393836298838a90e47"}[chunkId] + ".js";
};